import React, { useState, useEffect } from 'react';
import Select from "@awsui/components-react/select";
import Container from "@awsui/components-react/container";
import Header from "@awsui/components-react/header";
import SpaceBetween from "@awsui/components-react/space-between";
import Box from "@awsui/components-react/box";


const API_ENDPOINT = 'https://29ofz3of23.execute-api.us-east-1.amazonaws.com/prod/query';

export function LLMPlaygroundComponent() {
    const [iframeDimensions, setIframeDimensions] = useState({
        width: '100%',
        height: '600px'
    });

    const [selectedKnowledgeBase, setSelectedKnowledgeBase] = useState({
        label: "External Competitor Data",
        value: "D9E3WLWNMR"
    });

    const [iframeUrl, setIframeUrl] = useState(() => {
        const pluginConfig = encodeURIComponent(JSON.stringify({
            BedrockKBConnector: {
                knowledgeBaseId: selectedKnowledgeBase.value
            }
        }));
        return `https://rzn6hnqk.chat.qbusiness.us-east-1.on.aws/?kb=${selectedKnowledgeBase.value}&pluginConfig=${pluginConfig}`;
    });

    const knowledgeBaseOptions = [
        { label: " External Competitor Data", value: "D9E3WLWNMR" },
        { label: "SFDC_Data", value: "P8L7DQELI8" },
        { label: "Marshal Data", value: "EPE7FE9YYD" },
        { label: "CI Highspot Data", value: "KCSFFIUVB9" }

    ];

    useEffect(() => {
        const updateDimensions = () => {
            const width = Math.max(450, window.innerWidth * 0.7);
            const height = Math.max(400, window.innerHeight * 0.6);

            setIframeDimensions({
                width: `${width}px`,
                height: `${height}px`
            });
        };

        updateDimensions();
        window.addEventListener('resize', updateDimensions);
        return () => window.removeEventListener('resize', updateDimensions);
    }, []);

    // Update iframe URL when knowledge base selection changes
    const handleKnowledgeBaseChange = ({ detail }) => {
        setSelectedKnowledgeBase(detail.selectedOption);

        // Pass knowledge base ID as both URL parameter and plugin configuration
        const pluginConfig = encodeURIComponent(JSON.stringify({
            BedrockKBConnector: {
                knowledgeBaseId: detail.selectedOption.value
            }
        }));

        setIframeUrl(`https://rzn6hnqk.chat.qbusiness.us-east-1.on.aws/?kb=${detail.selectedOption.value}&pluginConfig=${pluginConfig}`);

        // Optional: Send a message to the iframe to notify it of the change
        const iframe = document.querySelector('iframe');
        if (iframe && iframe.contentWindow) {
            try {
                iframe.contentWindow.postMessage({
                    type: 'KNOWLEDGE_BASE_CHANGED',
                    knowledgeBaseId: detail.selectedOption.value
                }, '*');
            } catch (e) {
                console.error('Error posting message to iframe:', e);
            }
        }
    };

    return (
        <Container
            header={
                <Header variant="h2">
                    Amazon Q Playground
                </Header>
            }
        >
            <SpaceBetween direction="vertical" size="l">


                <iframe
                    src={iframeUrl}
                    style={{
                        width: iframeDimensions.width,
                        height: iframeDimensions.height,
                        border: '1px solid #ccc',
                        borderRadius: '4px'
                    }}
                    title="CI Playground Powered by Amazon Q"
                    key={selectedKnowledgeBase.value} // Force iframe reload when KB changes
                />
            </SpaceBetween>
        </Container>
    );
}